import { guid } from "traveldesk-ui"
import ItineraryStopModel from "./ItineraryStopModel"

export default class ItineraryModel {
    public static Create(obj: ItineraryModel) {
        return Object.assign(new ItineraryModel(obj.tourId, obj.index), obj, {
            guid: obj.guid || guid(),
            stops: obj.stops.map(x => ItineraryStopModel.Create(x)).sort((a, b) => a.index - b.index)
        })
    }
    constructor(tourId: number, index: number) {
        this.tourId = tourId
        this.index = index
        this.stops = []
    }
    guid: string = ''
    id: number = 0
    index: number = 0
    tourId: number = 0
    name: string = ''
    stops: ItineraryStopModel[] = []
}